import { useBattleCardsStore } from 'store/battlecards.store';

import { DisplayStyle } from 'components/common/ToggleView/ToggleView';

import ColumnsBoard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/ColumnsBoard/ColumnsBoard';

export const ColumnsBoardWrapper = () => {
    const { displayStyle } = useBattleCardsStore();
    if (displayStyle === DisplayStyle.ROWS) return null;

    return <ColumnsBoard />;
};
